


































































































































































import { Validate } from "vuelidate-property-decorators";
import { Component, Vue } from "vue-property-decorator";
import { required, email, sameAs, minLength } from "vuelidate/lib/validators";
import firebase from "firebase/app";
import "firebase/auth";
import * as firebaseui from "firebaseui";
import * as M from "materialize-css";
@Component
export default class SignUp extends Vue {
  @Validate({ required })
  name = "";
  @Validate({ required })
  lastname = "";
  @Validate({ required, email })
  email = "";
  @Validate({ required, maxLength: minLength(6) })
  password = "";
  @Validate({ required, sameAs: sameAs("password") })
  repeatPassword = "";

  mounted() {
    let ui = firebaseui.auth.AuthUI.getInstance();
    if (!ui) {
      const auth = firebase.auth();
      ui = new firebaseui.auth.AuthUI(auth);
    }
    const uiConfig = {
      signInSuccessUrl: "/login",
      signInOptions: [firebase.auth.GoogleAuthProvider.PROVIDER_ID],
      tosUrl: "https://evoluq.com",
      // Privacy policy url.
      privacyPolicyUrl: "https://evoluq.com/policy"
    };
    ui.start("#firebaseui-auth-container", uiConfig);
    this.$nextTick(M.updateTextFields);
  }

  public signup(): void {
    this.$v.$touch();
    if (!this.$v.$invalid) {
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(
          async () => {
            const currentUser = firebase.auth().currentUser;
            if (currentUser) {
              await currentUser.updateProfile({
                displayName: `${this.name} ${this.lastname}`
              });
            }
            firebase
              .auth()
              .signOut()
              .then(() => {
                this.$router.push("/login");
              });
          },
          err => {
            console.log("ERROR: " + err);
          }
        );
    }
  }
}
